import { m8API } from 'services/production/m8';
import { normalizeM8PartnerDTO } from 'services/production/utils/normalizeM8PartnerDTO';
import { GetPartnerByCodeService } from 'types/services';

export const getPartnerByCode: GetPartnerByCodeService = async (
  partnerCode
) => {
  const m8PartnerDTO = await m8API.user.getPartnerByCode({
    partnerCode,
  });

  return normalizeM8PartnerDTO(m8PartnerDTO).toPartner();
};
